import { render, staticRenderFns } from "./ServiceSelector.vue?vue&type=template&id=0ff3bff7"
import script from "./ServiceSelector.vue?vue&type=script&lang=js"
export * from "./ServiceSelector.vue?vue&type=script&lang=js"
import style0 from "./ServiceSelector.vue?vue&type=style&index=0&id=0ff3bff7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default,PlayMixServiceModal: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/PlayMix/ServiceModal.vue').default})
